import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3qslfm3vqg6y3 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { OBJECT_getInstance167untwb9admi as OBJECT_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from '../descriptors/SerialDescriptors.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
  return (p0) => p0.r1m();
}
var ObjectSerializerClass;
function ObjectSerializer() {
  if (ObjectSerializerClass === VOID) {
    class $ {
      constructor(serialName, objectInstance) {
        this.b20_1 = objectInstance;
        this.c20_1 = emptyList();
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.d20_1 = lazy(tmp_0, () => {
          var tmp = OBJECT_getInstance();
          return buildSerialDescriptor(serialName, tmp, [], ($this$buildSerialDescriptor) => {
            $this$buildSerialDescriptor.e1n_1 = this.c20_1;
            return Unit_instance;
          });
        });
      }
      r1m() {
        var tmp0 = this.d20_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
        return tmp0.n3();
      }
      l1n(encoder, value) {
        encoder.i1r(this.r1m()).j1r(this.r1m());
      }
      s1m(encoder, value) {
        return this.l1n(encoder, !(value == null) ? value : THROW_CCE());
      }
      t1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.r1m();
        var composite = decoder.i1r(descriptor);
        var tmp$ret$1;
        $l$block_0: {
          if (composite.y1r()) {
            tmp$ret$1 = Unit_instance;
            break $l$block_0;
          }
          var index = composite.z1r(this.r1m());
          if (index === -1) {
            tmp$ret$1 = Unit_instance;
            break $l$block_0;
          } else
            throw SerializationException().m1o('Unexpected index ' + index);
        }
        var result = tmp$ret$1;
        composite.j1r(descriptor);
        return this.b20_1;
      }
    }
    initMetadataForClass($, 'ObjectSerializer', VOID, VOID, [KSerializer()]);
    ObjectSerializerClass = $;
  }
  return ObjectSerializerClass;
}
//region block: exports
export {
  ObjectSerializer as ObjectSerializer2kjkucmygguwd,
};
//endregion

//# sourceMappingURL=ObjectSerializer.mjs.map
